// src/components/LoadingButton.tsx
import { Button, CircularProgress, ButtonProps } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
}

export default function LoadingButton({ loading = false, children, ...rest }: LoadingButtonProps) {
  const { t } = useTranslation<"translation">();

  return (
    <Button
      disabled={loading || rest.disabled}
      aria-label={loading ? (t("loadingButton.loading") as string) : undefined}
      {...rest}
    >
      {loading && <CircularProgress size={20} sx={{ mr: 1, color: "inherit" }} />}
      {children}
    </Button>
  );
}
